import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromReminder from './store/reminder.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ReminderEffects } from './store/reminder.effects';
import { ReminderContainerComponent } from './reminder-container/reminder-container.component';
import { ReminderComponent } from './reminder/reminder.component';
import { ReminderRoute } from './reminder.route';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { ReminderAddComponent } from './reminder-add/reminder-add.component';

@NgModule({
    declarations: [ReminderContainerComponent, ReminderComponent, ReminderAddComponent],
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(
            fromReminder.remindersFeatureKey,
            fromReminder.reducer
        ),
        EffectsModule.forFeature([ReminderEffects]),
        UIRouterModule.forChild({
            states: [ReminderRoute]
        })
    ]
})
export class ReminderModule {}
